import React from 'react';
import { CHAT_REACTION_CONFIG } from '../shared/chatReactionConfig';
import '../../../../css/common/chat/ChatMessageReactions.css';

const ChatMessageMenuReactionPicker = ({
  messageId = '',
  reactions = [],
  onSelectReaction = null,
  isPending = null,
}) => {
  const normalizedMessageId = String(messageId || '').trim();
  if (!normalizedMessageId || typeof onSelectReaction !== 'function') return null;

  const activeTypeSet = new Set(
    (Array.isArray(reactions) ? reactions : [])
      .filter((reaction) => Boolean(reaction?.reactedByMe))
      .map((reaction) => String(reaction?.type || '').trim())
      .filter(Boolean)
  );

  return (
    <div className="chat-message-menu-reaction-picker" role="group" aria-label="リアクションを付ける">
      {CHAT_REACTION_CONFIG.map((config) => {
        const isActive = activeTypeSet.has(config.type);
        const pending = typeof isPending === 'function' ? isPending(normalizedMessageId, config.type) : false;
        return (
          <button
            key={`${normalizedMessageId}:${config.type}`}
            type="button"
            className={[
              'chat-message-menu-reaction-picker__button',
              isActive ? 'chat-message-menu-reaction-picker__button--active' : '',
            ].filter(Boolean).join(' ')}
            data-reaction-type={config.type}
            onClick={async (event) => {
              event.preventDefault();
              event.stopPropagation();
              await onSelectReaction(normalizedMessageId, config.type);
            }}
            disabled={pending}
            aria-label={config.label}
            title={config.label}
          >
            <i className={config.iconClassName} aria-hidden="true"></i>
          </button>
        );
      })}
    </div>
  );
};

export default ChatMessageMenuReactionPicker;
